(() => {
  if (window.EpeiosKettleNoCode?.booted) {
    window.EpeiosKettleNoCode.init();
    return;
  }
  const track = (root, name, detail = {}) => {
    const payload = { event: `epeios_kettle_${name}`, section_id: root.dataset.sectionId || '', ...detail };
    root.dispatchEvent(new CustomEvent('epeios:kettle', { detail: payload }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  const initFinder = (root) => {
    if (!root.matches('[data-ek-finder]') || root.dataset.ekFinderReady === 'true') return;
    root.dataset.ekFinderReady = 'true';
    const answers = {};
    const choices = root.querySelectorAll('[data-ek-choice]');
    const result = root.querySelector('[data-ek-result]');
    const reset = root.querySelector('[data-ek-reset]');

    const calculate = () => {
      if (!answers.use || !answers.cups || !answers.priority) return;
      const totals = { lite: 0, flow: 0, lux600: 0, lux900: 0 };
      Object.values(answers).forEach((button) => {
        Object.keys(totals).forEach((model) => {
          totals[model] += Number(button.dataset[`score${model.charAt(0).toUpperCase()}${model.slice(1)}`] || 0);
        });
      });
      let best = 'flow';
      Object.keys(totals).forEach((model) => {
        if (totals[model] > totals[best]) best = model;
      });
      const config = root.querySelector(`[data-ek-result-config="${best}"]`);
      if (!config || !result) return;
      result.querySelector('[data-ek-result-name]').textContent = config.dataset.name || best;
      result.querySelector('[data-ek-result-copy]').textContent = config.dataset.copy || '';
      const link = result.querySelector('[data-ek-result-link]');
      link.textContent = config.dataset.cta || link.textContent;
      link.href = config.dataset.url || '#epeios-kettle-products';
      result.hidden = false;
      if (reset) reset.hidden = false;
      track(root, 'quiz_complete', { model: best, scores: totals });
    };

    choices.forEach((button) => {
      button.addEventListener('click', () => {
        const question = button.dataset.question;
        root.querySelectorAll(`[data-ek-choice][data-question="${question}"]`).forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        answers[question] = button;
        track(root, 'quiz_select', { question, answer: button.dataset.answer || '' });
        calculate();
      });
    });

    if (reset) reset.addEventListener('click', () => {
      Object.keys(answers).forEach((key) => delete answers[key]);
      choices.forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
      if (result) result.hidden = true;
      reset.hidden = true;
      track(root, 'quiz_reset');
    });
  };

  const initProducts = (root) => {
    if (!root.matches('[data-ek-products]') || root.dataset.ekProductsReady === 'true') return;
    root.dataset.ekProductsReady = 'true';
    root.querySelectorAll('[data-ek-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.ekFilter;
        root.querySelectorAll('[data-ek-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
        root.querySelectorAll('[data-ek-card]').forEach((card) => {
          const uses = (card.dataset.use || '').split(' ');
          card.classList.toggle('is-filtered', filter !== 'all' && !uses.includes(filter));
        });
        track(root, 'filter_click', { filter });
      });
    });
  };

  const initTracking = (root) => {
    if (root.dataset.ekTrackingReady === 'true') return;
    root.dataset.ekTrackingReady = 'true';
    root.querySelectorAll('[data-ek-event]').forEach((element) => {
      element.addEventListener('click', () => track(root, element.dataset.ekEvent, { model: element.dataset.model || '' }));
    });
  };

  const init = (scope = document) => {
    const roots = scope.matches?.('.ek[data-section-id]') ? [scope] : scope.querySelectorAll?.('.ek[data-section-id]') || [];
    roots.forEach((root) => {
      initFinder(root);
      initProducts(root);
      initTracking(root);
    });
  };

  window.EpeiosKettleNoCode = { init, booted: true };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();